/* eslint-disable */
import actionTypes from '../constants/actionTypes'
import fetchHelper from '../utils/fetchHelper'
import exceptionHelper from '../utils/exceptionHelper'
import { captureFetchException } from '../utils/sentryUtils'
import { message } from 'antd'
import { buildParamsWithAuthPolicy } from './photo'
import {
  setExportWatermarkFilter,
  resetExportWatermarkFilter,
  setPhotoWatermarkQueryFilter,
  setPhotosWatermarksTotalPhotos as setPhotosWatermarksTotalPhotosAction,
  triggerPhotoWaterMarkExcel,
  setAiRecognitionResults
} from '../slices/photoWatermarkSlice'

export function setFilter(data) {
  return (dispatch, getState) => {
    dispatch(setExportWatermarkFilter(data))
    return Promise.resolve()
  }
}

export function setQueryFilter(data) {
  return (dispatch, getState) => {
    dispatch(setPhotoWatermarkQueryFilter(data))
    return Promise.resolve()
  }
}

export function resetFilter() {
  return (dispatch, getState) => {
    dispatch(resetExportWatermarkFilter())
    // 返回重置后的 queryFilter，供调用方同步更新 ref
    return Promise.resolve(getState().photoWatermark.queryFilter)
  }
}

export function setPhotosWatermarksTotalPhotos(data) {
  return (dispatch, getState) => {
    dispatch(setPhotosWatermarksTotalPhotosAction(data))
    return Promise.resolve()
  }
}
export function setTriggerPhotoWaterMarkExcel(data) {
  return (dispatch, getState) => {
    dispatch(triggerPhotoWaterMarkExcel(data))
    return Promise.resolve()
  }
}

export function fetchPhotos(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/photo/watermark/search',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(buildParamsWithAuthPolicy(getState(), data))
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      })
  }
}

export function fetchPhotoWatermarkExcel(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/photo/watermark/export',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        // captureFetchException(err, config)
        //服务端没有详细说明会有哪些错误情况。将所有错误的msg透传显示，不用上报Sentry
        message.error(err?.data?.msg || '导出失败，请稍后重试！')
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      })
  }
}

export function fetchExtraColumnTitles(data) {
  return (dispatch, getState) => {
    dispatch({
      type: actionTypes.SET_LOADING,
      data: true
    })
    let config = {
      url: __API_SERVER_HOST__ + '/web/workgroup/photo/watermark/title/search',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(buildParamsWithAuthPolicy(getState(), data))
      }
    }
    return fetchHelper(dispatch, getState, config)
      .then((result) => exceptionHelper(result))
      .catch((err) => {
        captureFetchException(err, config)
        return Promise.reject(null)
      })
      .finally(() => {
        dispatch({
          type: actionTypes.SET_LOADING,
          data: false
        })
      })
  }
}

// AI提取接口
export function fetchAiRecognition(params, signal) {
  return (dispatch, getState) => {
    let config = {
      url:
        __API_SERVER_HOST__ +
        '/web/workgroup/photo/watermark/ai_recognition/create',
      arguments: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(buildParamsWithAuthPolicy(getState(), params)),
        signal: signal
      }
    }

    return fetchHelper(dispatch, getState, config)
      .then((result) => {
        if (result && result.code === 200) {
          dispatch(setAiRecognitionResults(result.data))
        }
        return result
      })
      .catch((err) => {
        if (err.name === 'AbortError') {
          // 请求被取消，不显示错误信息
          return Promise.reject(err)
        }
        captureFetchException(err, config)
        return Promise.reject(err)
      })
  }
}
